<div class="alerts-form-wrapper" data-cy="alerts-form">
  @if (spinnerObservable | async) {
    <div class="spinner-container alerts-form-spinner">
      <app-loading-spinner class="center-spinner"></app-loading-spinner>
    </div>
  }

  <app-alert-form-header
    [editAlertConfig]="editAlertConfig"
    [isViewMode]="isViewMode"
  (closeForm)="discardAlertNewConfig()"></app-alert-form-header>

  <app-alert-editable-form
    [editAlertConfig]="editAlertConfig"
    [isViewMode]="isViewMode"
    (onFormDataChanges)="onAlertEditableFormDataChange($event)"
  ></app-alert-editable-form>

  <app-alert-form-footer [editAlertConfig]="editAlertConfig"
    [isViewMode]="isViewMode"
    [isValidToApply]="state.isValidToApply"
    [hasEditPermission]="hasEditPermission"
    (primaryButtonAction)="footerButtonPrimaryAction()"
  (secondaryButtonAction)="footerButtonSecondaryAction()"></app-alert-form-footer>
</div>
